module.exports = __webpack_public_path__ + "static/media/bottom-banner.19245e6e.jpg";